import { isPlatformBrowser } from '@angular/common';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import {
  Inject,
  Injectable,
  makeStateKey,
  TransferState,
  PLATFORM_ID,
} from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable()
export class BrowserStateInterceptor implements HttpInterceptor {
  constructor(
    private readonly transferState: TransferState,
    @Inject(PLATFORM_ID) private readonly plateformId: string
  ) {}

  public intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (isPlatformBrowser(this.plateformId) && req.method === 'GET') {
      const key = makeStateKey(req.url);
      const storedResponse = this.transferState.get<unknown>(key, null);

      if (storedResponse) {
        this.transferState.remove(key);

        return of(new HttpResponse({ body: storedResponse, status: 200 }));
      }
    }

    return next.handle(req);
  }
}
